/**
 * Whether Audit Coverage should show "Upgrade to audit all products"
 * vs "Audit all products" (plan allows more audits; user has not run them yet).
 */
function resolveQuota(quota, cacheMetadata) {
  return quota ?? cacheMetadata?.quota_usage ?? null;
}

function isPaidAccount(accountType) {
  const t = String(accountType || '').toLowerCase();
  return t !== '' && t !== 'trial';
}

/**
 * @param {{ unlimited?: boolean; remaining?: number; accountType?: string } | null | undefined} quota
 * @param {{ trialLimited?: boolean; upgradeRequired?: boolean; quota_usage?: { unlimited?: boolean; remaining?: number; accountType?: string } } | null | undefined} cacheMetadata
 */
export function shouldShowUpgradeToAuditAllProducts(quota, cacheMetadata) {
  const q = resolveQuota(quota, cacheMetadata);
  const accountType = q?.accountType ?? cacheMetadata?.accountType;

  if (q?.unlimited === true) {
    return false;
  }

  // Paid plans: never gate "audit all" behind upgrade (validate may still enforce quota).
  if (isPaidAccount(accountType)) {
    return false;
  }

  // Unlimited plans encode remaining as -1; any positive remaining also allows audit.
  if (q != null && typeof q.remaining === 'number' && q.remaining !== 0) {
    return false;
  }

  if (cacheMetadata?.trialLimited === true || cacheMetadata?.upgradeRequired === true) {
    return true;
  }

  // Trial at SEO audit cap (no remaining audits).
  return Boolean(q && q.unlimited !== true && q.remaining === 0);
}
